import * as React from 'react';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
import { getSearchBoxLeftPadding } from 'owa-calendar-layout';
import { AccountScopePicker, CalendarSearchBoxContainer } from 'owa-calendar-search-view';
import type { SearchBoxContainerHandle } from 'owa-search';
import { CalendarModuleDiagnosticsPanel } from 'owa-calendar-diagnostics';

export default function getCalendarHeaderProps(
    searchBoxRef: React.RefObject<SearchBoxContainerHandle>
) {
    return {
        props: isHostAppFeatureEnabled('renderCalendarHeader')
            ? {
                  searchAlignmentWidth: getSearchBoxLeftPadding(),
                  renderSearch: () => <CalendarSearchBoxContainer ref={searchBoxRef} />,
                  renderSearchScopePicker: () => <AccountScopePicker searchBoxRef={searchBoxRef} />,
                  DiagnosticsPanel: CalendarModuleDiagnosticsPanel,
                  enableResponsiveLayout: true,
              }
            : undefined,
    };
}
